import { standardUpdateApi } from "../../api/standard/standardUpdateApi"

type PayloadShape = Parameters<typeof standardUpdateApi>[0]

export async function standardUpdateService(payload: PayloadShape, token: string) {
	return await standardUpdateApi(payload, token)
}
